import React, { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  Divider,
  TextareaAutosize,
  Link,
  TextField,
} from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import ReCAPTCHA from "react-google-recaptcha";
import consts from "../../../main/consts";

import { StorageUser } from "../../../main/StorageUser";
import Authorization from "../Authorization";

const CODS_SAP = consts.CODS_SAP?.split(",");

const useStyles = makeStyles((theme) => ({
  box: {
    borderLeft: `5px solid#FFAA00`,
  },
  title: {
    padding: 10,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  listContent: {
    maxHeight: "50vh",
    minWidth: 380,
    minHeight: 80,
  },
  text: {
    height: "100%",
  },
  spacingBottom: {
    marginBottom: 10,
  },
  action: {
    padding: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  numeroPedido: {
    marginTop: 10,
  },
  motivo: {
    marginTop: 25,
    display: "flex",
  },
  recaptcha: {
    marginTop: 15,
  },
  icon: {
    color: "#FFAA00",
  },
  button: {
    backgroundColor: green[500],
    color: "#fff",
    marginLeft: 40,
  },
  hr: {
    width: "100%",
    borderBottom: "1px solid #EEE",
    border: "none",
  },
}));

const RetornarPopup = (props) => {
  const {
    open,
    handleClose,
    handleConfirm,
    numero,
    status,
    associado,
    origem,
    codigoExterno,
    itens = [],
    auth,
  } = props;
  const classes = useStyles();
  const [motivoDevolucao, setMotivoDevolucao] = useState(null);
  const [recaptcha, setRecaptcha] = useState(!!consts.DISABLE_RECAPTCHA);

  const storageUser = new StorageUser();

  const requireAutorizador = storageUser.allowedByPermission(
    "INLINE_CANCEL_CONFIRM"
  );

  const disabled =
    status === "FINALIZADO" &&
    (motivoDevolucao == null || motivoDevolucao === "" || !recaptcha);

  const handleSubmit = ({ nomeAutorizador, emailAutorizador } = {}) => {
    handleConfirm(
      numero,
      status,
      associado,
      origem,
      codigoExterno,
      motivoDevolucao,
      nomeAutorizador,
      emailAutorizador
    );
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <Box className={classes.box}>
          <Box className={classes.title}>
            <WarningIcon className={classes.icon} fontSize="large" />
            <DialogTitle className={classes.title}>
              <strong>ATENÇÃO</strong>
            </DialogTitle>
          </Box>
          <Divider />
          {status === "FINALIZADO" &&
            CODS_SAP.some((r) => itens.map((i) => i.codigoSAP).includes(r)) &&
            !auth.isAdmin ? (
            <DialogContent className={classes.listContent}>
              <Box
                direction="column"
                justify="space-between"
                alignItems="center"
                className={classes.text}
              >
                <Typography align="center">
                  <strong>Item bloqueado para devolução no Maestro.</strong>
                </Typography>
                <br />
                <Typography textAlign="justify">
                  Informamos que para solicitação de atendimento para Consoles e
                  Games, será necessário o preenchimento do formulário, no link
                  a seguir:
                </Typography>
                <Typography align="center">
                  (
                  <Link
                    href={"https://forms.office.com/r/fQGQWQs0Qy"}
                    target="_blank"
                    color={"blue"}
                  >
                    https://forms.office.com/r/fQGQWQs0Qy
                  </Link>
                  ).
                </Typography>
                <br />
                <Typography textAlign="justify">
                  Esclarecemos que o prazo de retorno é de 07 dias corridos, e a
                  loja deverá comunicar o cliente sobre o posicionamento e
                  devolver o produto ao cliente. Lembrando que todas as
                  informações contidas no formulário devem ser verificadas no
                  produto com a penalidade do item ser estornado para a loja,
                  caso seja verificado inconformidade entre o formulário e o
                  produto. Elaboramos um manual para ajudar a identificar as
                  principais anomalias dos consoles, que foi enviado por e-mail.
                </Typography>
                <br />
              </Box>
            </DialogContent>
          ) : (
            <>
              <DialogContent
                className={classes.listContent}
                style={{ overflow: "hidden" }}
              >
                <Box
                  direction="column"
                  justify="space-between"
                  alignItems="center"
                  className={classes.text}
                >
                  <Typography>
                    <strong>
                      {status === "RETORNAR_PARA_ESTOQUE"
                        ? "Tem certeza que de deseja retornar para estoque?"
                        : "Cliente está com o produto e seus respectivos componentes na loja para fazer devolução?"}
                    </strong>
                  </Typography>
                </Box>
                <Box className={classes.numeroPedido}>
                  <Typography>Nº do Pedido: {numero}</Typography>
                </Box>
                {status === "FINALIZADO" && (
                  <>
                    <Box className={classes.motivo}>
                      <TextareaAutosize
                        fullWidth
                        variant="outlined"
                        placeholder="Digite aqui o Motivo de Devolução..."
                        name="motivoDevolucao"
                        id="motivoDevolucao"
                        margin="dense"
                        rowsMin={4}
                        value={motivoDevolucao}
                        style={{ flex: 1, padding: 10 }}
                        onChange={(e) => {
                          setMotivoDevolucao(e.target.value);
                        }}
                      />
                    </Box>
                    <Box className={classes.recaptcha}>
                      {!consts.DISABLE_RECAPTCHA && (
                        <ReCAPTCHA
                          sitekey={consts.RECAPTCHA_KEY}
                          onChange={(e) => setRecaptcha(true)}
                        />
                      )}
                    </Box>
                  </>
                )}
              </DialogContent>
              <Divider />

              {(status === "FINALIZADO" ||
                status === "RETORNAR_PARA_ESTOQUE") &&
                requireAutorizador && (
                  <Authorization
                    action={handleSubmit}
                    disabled={disabled}
                    cancel={handleClose}
                    cancelText="não"
                    actionText="sim"
                    endIcon={<CheckIcon />}
                  />
                )}

              {!(
                (status === "FINALIZADO" ||
                  status === "RETORNAR_PARA_ESTOQUE") &&
                requireAutorizador
              ) && (
                  <Box className={classes.action}>
                    <Button
                      onClick={handleClose}
                      variant="contained"
                      color="primary"
                      startIcon={<CloseIcon />}
                      autoFocus
                    >
                      Não
                    </Button>
                    <Button
                      disabled={disabled}
                      onClick={handleSubmit}
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      startIcon={<CheckIcon />}
                      autoFocus
                    >
                      Sim
                    </Button>
                  </Box>
                )}
            </>
          )}
        </Box>
      </Dialog>
    </>
  );
};

export default RetornarPopup;
